<template>
  <div class="wrap">
    <div class="left-wrap">
      <div class="" v-if="question.choice5 != ''"><span v-if="question.choice5 != ''">-{{ question.choice5 }}-</span></div>
      <p :class="'pi-' + question.id" v-html="question.question1"></p>
    </div>
    <div class="center-border"></div>
    <div class="right-wrap">
      <div class="mb-3">
        問{{ question.no }}
      </div>
      <p :class="'qi-' + question.id" v-html="question.question2"></p>
      <ol class="Ar2jysLK"  v-if="questions[index].currentChoiceArr.length > 0">
        <li v-for="(answer, i) in answers" :key="i" class="pl-2" :class="{ 'Gm8W5aZb': questions[index].isBookmarkArr[i] }">
          <div class="d-flex align-items-center">
            <input type="checkbox" v-model="questions[index].isBookmarkArr[i]" @click="bookmark(i)" class="G6zckbvr " :class="{'eJ7LMsiQ': questions[index].isBookmarkArr[i]}">
            <div class="flex-1">
              <span v-if="answers.length > 1">
            <span v-if="i == 0">①</span>
            <span v-if="i == 1">②</span>
            <span v-if="i == 2">③</span>
            <span v-if="i == 3">④</span>
            に最も適切な数値を入力してください。</span>（単位：
            <span v-if="i == 0">{{ questions[index].choice1 }}</span>
            <span v-if="i == 1">{{ questions[index].choice2 }}</span>
            <span v-if="i == 2">{{ questions[index].choice3 }}</span>
            <span v-if="i == 3">{{ questions[index].choice4 }}</span>
            ）
            </div>
          </div>
          <div class="pl-4 mt-2">
            <input class="text-r mr-3" type="text" @change="answerExe(i)" @focus="rmComma" @blur="onlyNumber($event, i)" v-model="questions[index].currentChoiceArr[i]">
            
          </div>
        </li>
      </ol>
      <div style="height: 250px;"></div>
    </div>


  </div>
</template>


<script lang="ts">
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import Question from "../../models/question";
import StorageService from "../../services/storage";
import question from "@/services/question";
import BasicUtil from "@/services/basicUtil";
@Component({
  components: {}
})
export default class Double extends Vue {
  @Prop()
  private question!: Question;
  @Prop()
  private index!: number;
  @Prop()
  private indexs!: number[];
  @Prop()
  public questions!: Question[]


  private answers: string[] = []

  private isLock: boolean = false;
  created() {
    if (this.questions[this.index].isBookmarkArr == undefined) this.questions[this.index].isBookmarkArr = [false, false, false, false]
  }
  mounted() {
    this.answers = String(this.questions[this.index].answer).split(",")
    if (this.questions[this.index].currentChoiceArr.length == 0) {
      const results = []
      for (let i = 0; i < this.answers.length; i++) {
        this.questions[this.index].currentChoiceArr.push("")
        results.push(false)
      }
      this.questions[this.index].results = results
    }

      for (let i = 0; i < this.questions[this.index].currentChoiceArr.length; i++) {
        if (this.questions[this.index].currentChoiceArr[i].length > 0 && !this.questions[this.index].currentChoiceArr[i].includes(",")) {
          // shikenId = 11 かつ no = 4 の問題の場合、小数点以下を保持する
          if ((this.question.shikenId === 11 && this.question.no === 4)
            || (this.question.shikenId === 15 && this.question.no === 4)) {
            this.questions[this.index].currentChoiceArr[i] = new BasicUtil().onlyNumberMinusKeepDecimal(this.questions[this.index].currentChoiceArr[i])
          } else {
            this.questions[this.index].currentChoiceArr[i] = Number(this.questions[this.index].currentChoiceArr[i]).toLocaleString()
          }
        }
      }
  }

  private bookmark(index: number) {
    if (this.questions[this.index].isBookmarkArr == undefined) this.questions[this.index].isBookmarkArr = [false, false, false, false]
    if (this.questions[this.index].isBookmarkArr[index] == undefined) this.questions[this.index].isBookmarkArr[index] = false
    this.questions[this.index].isBookmarkArr[index] = !this.questions[this.index].isBookmarkArr[index];

    this.$store.commit("setQuestions", this.questions);
    this.answerEmit();
  }


  @Emit("answerEmit")
  answerEmit() {
    return
  }

  public async answerExe(i: number) {
    this.questions[this.index].results[i] = this.answers[i] == this.questions[this.index].currentChoiceArr[i].replace(/[^0-9.-]/g, '');
    this.$store.commit("setQuestions", this.questions);
    this.answerEmit();
  }

  onlyNumber(e: any, i: number) {
      // 小数点以下の0を保持する必要がある問題の場合は専用メソッドを使用
      if ((this.question.shikenId === 19 && this.question.no === 4)
        || (this.question.shikenId === 11 && this.question.no === 4)
        || (this.question.shikenId === 15 && this.question.no === 4)) {
        e.target.value = new BasicUtil().onlyNumberMinusKeepDecimal(e.target.value)
      } else {
        e.target.value = new BasicUtil().onlyNumberMinus(e.target.value)
      }
      this.questions[this.index].currentChoiceArr[i] = String(e.target.value)
    }
    rmComma(e: any) {
      e.target.value = String(e.target.value).replace(/,/g, "")
    }
}
</script>

<style scoped>
.wrap {
  margin: -1.5em !important;
  height: calc(100vh - 120px - 90px);
  display: flex;
  align-items: stretch;

}

.right-wrap {
  width: calc(50% - 1px);
  padding: 1.5em;
  overflow-y: scroll;
}

.center-border {
  width: 2px;
  background-color: #ccc;
  height: 100%;
}

.left-wrap {
  width: calc(50% - 1px);
  padding: 1.5em;
  overflow-y: scroll;
}
.text-r {
  text-align: right;
}
.pl-4 {
  padding-left: 1.5em;
}
.pl-2 {
  padding-left: 0.5em;
}
.flex-1 {
  flex:1;
}
</style>
<style>
.left-wrap img {
  width: 100% !important;
}

.right-wrap img {
  max-width: 100%;
}
</style>
